import React, { useEffect, useMemo, useState } from 'react';
import { IconButton } from '@material-ui/core';
import { MoreVert, Save as SaveIcon } from '@material-ui/icons';
import * as S from '../styles';
import { Button, Input, PaginatedTable, Modal } from '../../../../_core/_components';
import { FullScreenLoading } from '../../../../_core/_components/fullscreen-loading';
import api from '../../../../_core/api';

import { handleErrors } from '../../../../_core/services/toast';
import { TipoContratoDTO, TipoContrato as TipoContratoType } from './types';
import { ModalContent } from './modal-content';

export function TipoContrato(): JSX.Element {
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [registerList, setRegisterList] = useState<TipoContratoDTO>();
  const [tipoContrato, setTipoContrato] = useState<TipoContratoType>();
  const [page, setPage] = useState(1);

  useEffect(() => {
    getData();
  }, [page]);

  const getData = async () => {
    setLoading(true);
    try {
      const { data } = await api.get<TipoContratoDTO>(`/config/inadimplencia/tipo-contrato?page=${page}`);
      setRegisterList(data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const filteredItems = useMemo(() => {
    if (searchText) {
      const filtered = registerList?.data.filter(reg => reg.codigo.toUpperCase().includes(searchText.toUpperCase()));
      return filtered ?? [];
    }
    return registerList?.data ?? [];
  }, [searchText, registerList]);

  const renderedData = useMemo(() => {
    if (filteredItems.length > 0) {
      return filteredItems.map(item => ({
        ...item,
        actions: (
          <IconButton
            aria-controls="simple-menu"
            aria-haspopup="true"
            color="primary"
            component="span"
            id={item.id!.toString()}
            onClick={() => setTipoContrato(item)}
          >
            <MoreVert />
          </IconButton>
        ),
      }));
    }
    return [];
  }, [filteredItems]);

  const addItem = () =>
    setTipoContrato({
      codigo: '',
      ativo: true,
      descricao: '',
    });

  const saveItem = async () => {
    setLoading(true);
    try {
      if (tipoContrato!.id) {
        await api.put(`/config/inadimplencia/tipo-contrato/${tipoContrato!.id}`, tipoContrato);
      } else {
        await api.post('/config/inadimplencia/tipo-contrato', tipoContrato);
      }
      const { data } = await api.get<TipoContratoDTO>('/config/inadimplencia/tipo-contrato?page=1');
      setTipoContrato(undefined);
      setRegisterList(data);
    } catch (error) {
      handleErrors(error);
    }
    setLoading(false);
  };

  return (
    <S.DataContainer>
      <FullScreenLoading isEnabled={loading} />
      {tipoContrato && (
        <Modal
          title="Adicionar/Editar Tipo Movimento"
          onClose={() => setTipoContrato(undefined)}
          content={<ModalContent state={[tipoContrato, setTipoContrato]} />}
          actionItems={[<Button onClick={saveItem} text="Salvar" startIcon={<SaveIcon />} />]}
        />
      )}
      <S.TopBar>
        <S.SearchBar>
          <S.SearchField>
            <Input label="Buscar" state={[searchText, setSearchText]} />
          </S.SearchField>
        </S.SearchBar>
        <Button text="Criar novo" onClick={addItem} />
      </S.TopBar>
      {renderedData.length > 0 && (
        <PaginatedTable
          columns={[
            { label: 'Id', key: 'id' },
            { label: 'Código', key: 'codigo' },
            { label: 'Descrição', key: 'descricao' },
            { label: 'Editar', key: 'actions' },
          ]}
          data={renderedData}
          pagination={registerList!.pageInfo}
          onChangePage={setPage}
        />
      )}
    </S.DataContainer>
  );
}
